import React, { useEffect, useRef } from "react";

// A soft gold light-trail that follows the cursor — the "truth" travelling with you.
// Desktop + fine-pointer only; respects reduced-motion.
export default function CursorGlow() {
  const ref = useRef(null);
  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || reduce) return;
    const el = ref.current;
    let x = window.innerWidth / 2, y = window.innerHeight / 2, tx = x, ty = y, raf;
    const move = (e) => { tx = e.clientX; ty = e.clientY; el.style.opacity = "1"; };
    const leave = () => { el.style.opacity = "0"; };
    const tick = () => {
      x += (tx - x) * 0.14; y += (ty - y) * 0.14;
      el.style.transform = `translate(${x}px, ${y}px)`;
      raf = requestAnimationFrame(tick);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseout", leave);
    raf = requestAnimationFrame(tick);
    return () => { window.removeEventListener("mousemove", move); window.removeEventListener("mouseout", leave); cancelAnimationFrame(raf); };
  }, []);
  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="hidden md:block fixed top-0 left-0 z-[60] pointer-events-none opacity-0 transition-opacity duration-500"
      style={{ width: 0, height: 0 }}
    >
      <div
        className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{ width: 260, height: 260, background: "radial-gradient(circle, rgba(212,175,55,0.16), rgba(212,175,55,0.05) 40%, transparent 68%)", mixBlendMode: "screen" }}
      />
      <div
        className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{ width: 8, height: 8, background: "rgba(232,212,139,0.9)", boxShadow: "0 0 12px 3px rgba(212,175,55,0.6)" }}
      />
    </div>
  );
}
